import { calculateDaysElapsed } from './calculators';

export const stateParamsForWelcome = () => {
  return { name: 'welcome' };
};

export const stateParamsForWeekly = () => {
  return { name: 'dashboard' };
};

export const stateParamsForUpdateCreditCard = isVerify => {
  return {
    name: 'profileCreditCard',
    params: { action: isVerify ? 'verify' : 'resume' },
  };
};

export const stateParamsForProgram = (
  startedAt,
  weeksCount,
  voomeProductId
) => {
  const daysElapsed = calculateDaysElapsed(startedAt);
  const weekNumber = Math.floor(daysElapsed / 7) + 1;

  return daysElapsed < 1
    ? { name: 'program.intro', params: { voomeProductId } }
    : weekNumber > weeksCount
      ? { name: 'program.graduation', params: { voomeProductId } }
      : { name: 'program.week.detail', params: { voomeProductId, weekNumber } };
};

export const stateParamsForSubscription = (subscription, redirectTo = {}) => {
  if (subscription) {
    const {
      isWeekly,
      startedAt,
      status,
      step,
      voomeProductId,
      weeksCount,
    } = subscription;

    // Verify credit card is an edge case that doesn't have a redirectTo
    const isVerify = /credit-card\/verify/.test(window.location.pathname);
    const isUpdate = /^(cancelled|suspended)$/.test(status);

    return isUpdate || isVerify
      ? stateParamsForUpdateCreditCard(isVerify)
      : step < 3
        ? stateParamsForWelcome()
        : redirectTo.name
          ? redirectTo
          : isWeekly
            ? stateParamsForWeekly()
            : stateParamsForProgram(startedAt, weeksCount, voomeProductId);
  } else {
    return {};
  }
};



// WEBPACK FOOTER //
// ./src/utils/stateParams.js